import { render, staticRenderFns } from "./TerminalAdsHeader.vue?vue&type=template&id=dd19b910&scoped=true"
import script from "./TerminalAdsHeader.vue?vue&type=script&lang=js"
export * from "./TerminalAdsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd19b910",
  null
  
)

export default component.exports